<template>
  <div class="content">
    <el-row :gutter="12">
      <el-col :span="17">
        <el-card>
          <div slot="header" class="rowStyle">
            <div class="basic-info">
              Order details
              <el-button
                style="float: right"
                icon="el-icon-arrow-left"
                size="small"
                @click="$router.go(-1)"
              >
              </el-button>

              <el-dropdown
                style="float: right; margin: 0px 5px"
                @command="handleCommand"
              >
                <el-button size="small">
                  More actions<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand('e')"
                    >edit</el-dropdown-item
                  >
                  <el-dropdown-item
                    :command="beforeHandleCommand('a', orderInfo.orderUrl)"
                    >添加商品</el-dropdown-item
                  >
                  <el-dropdown-item :command="beforeHandleCommand('r')"
                    >随机商品</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <el-button v-if="!isEditing"  style="float: right"  class="el-button el-button--primary" size="small" @click="handleEdit()">编辑</el-button>   -->
              <el-button
                v-if="isEditing"
                style="float: right"
                class="el-button el-button--primary"
                size="small"
                @click="handleSave()"
                >保存</el-button
              >
            </div>
          </div>
          <div class="clearfix">
            <span
              >Order ID:
              {{
                orderInfo.orderNo
                  ? orderInfo.orderNo
                  : "2024021706504304670088-0"
              }}</span
            >
          </div>
          <div class="clearfix">
            <time class="time"
              >Created at ：{{
                orderInfo.orderTime
                  ? orderInfo.orderTime
                  : "2024-05-04 11:45:43"
              }}</time
            >
          </div>
          <div class="clearfix">
            <el-tag size="mini" type="primary" v-if="orderInfo.status != '3'"
              >Ongoing</el-tag
            >
            <el-tag size="mini" type="info" v-if="orderInfo.status != '3'"
              >Paid</el-tag
            >

            <el-tag size="mini" type="success" v-if="orderInfo.status === '3'"
              >Completed</el-tag
            >
            <el-tag size="mini" type="info" v-if="orderInfo.status === '3'"
              >Refunded</el-tag
            >
            <el-tag size="mini" type="success" v-if="orderInfo.status === '3'"
              >After-sales completed</el-tag
            >
            <el-tag size="mini" type="warning">Fulfilled</el-tag>
          </div>
          <el-divider></el-divider>
          <div class="clearfix">
            <span>Total</span>
          </div>
          <div class="clearfix">
            <el-row :gutter="20">
              <el-col :span="12" style="border-right: 1px dashed #e5e5e5">
                <div class="clearfix">
                  <span>Item subtotal</span>
                  <span v-if="!isEditing" style="float: right">{{
                    PriceTotal ? PriceTotal + " USD" : "0.00 USD"
                  }}</span>
                  <!-- <input  v-else type="text" v-model="PriceTotal"  />      -->
                </div>
                <div class="clearfix">
                  <span>Total discounts</span>
                  <span v-if="!isEditing" style="float: right">{{
                    orderInfo.discount
                      ? orderInfo.discount + " USD"
                      : discount + " USD"
                  }}</span>
                  <input v-else type="text" v-model="orderInfo.discount" />
                </div>
                <div class="clearfix">
                  <span>Shipping</span>
                  <span v-if="!isEditing" style="float: right">{{
                    orderInfo.freight
                      ? orderInfo.freight + " USD"
                      : freight + " USD"
                  }}</span>
                  <input v-else type="text" v-model="orderInfo.freight" />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="clearfix">
                  <span
                    >Total
                    <el-tag
                      size="mini"
                      type="info"
                      v-if="orderInfo.status != '3'"
                      >Paid</el-tag
                    >
                    <el-tag
                      size="mini"
                      type="info"
                      v-if="orderInfo.status === '3'"
                      >Refunded</el-tag
                    >
                  </span>

                  <span style="float: right; color: #30354d">{{
                    orderInfo.orderAmount
                      ? orderInfo.orderAmount + " USD"
                      : "0.00 USD"
                  }}</span>
                </div>
                <div class="clearfix" v-if="orderInfo.status === '3'">
                  <span
                    >Refunded
                  </span>

                  <span style="float: right; color: #30354d">{{
                    orderInfo.orderAmount
                      ? "-" +orderInfo.orderAmount + " USD"
                      : "0.00 USD"
                  }}</span>
                </div>
                
              </el-col>
            </el-row>
          </div>
          <el-divider></el-divider>
          <div class="clearfix">
            <h4>Original order</h4>
          </div>
          <div
            class="clearfix product-info"
            v-for="(product, index) in productInfo"
            :key="product.id"
          >
            <div class="clearfix product-item">
              <el-row :gutter="20">
                <el-col :span="1">
                  <span>{{ index + 1 }}</span>
                </el-col>
                <el-col :span="2">
                  <el-image
                    style="width: 64px; height: 64px"
                    :src="product.pictureUrl"
                    @click="editImageUrl(product)"
                  ></el-image>
                </el-col>
                <el-col :span="12">
                  <div class="clearfix">
                    <el-link
                      :href="product.url"
                      class="info-name"
                      :underline="false"
                      target="_blank"
                      >{{ product.productName }}</el-link
                    >
                  </div>
                  <div class="clearfix info-item">
                    <span></span>
                    <span v-if="!isEditing">{{
                      product.size ? "Style：" + product.size : ""
                    }}</span>
                    <input v-else type="text" v-model="product.size" />
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="clearfix info-item">
                    <span
                      >{{ product.money ? product.money + " USD" : "0.00 USD" }}
                    </span>
                    <span>x</span>

                    <span v-if="!isEditing">{{
                      product.sum ? product.sum : "1"
                    }}</span>
                    <el-input-number
                      v-else
                      v-model="product.sum"
                      size="mini"
                      @change="handleChange"
                      :min="1"
                      :max="50"
                      label="num"
                    ></el-input-number>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="clearfix">
                    <div>
                      <span class="item-price">Total：</span>
                      <span class="item-price"
                        >{{
                          product.sum
                            ? roundToTwo(product.money * product.sum) + " USD"
                            : product.money * 1 + " USD"
                        }}
                      </span>
                      <button
                        v-if="isEditing"
                        aria-label="Close"
                        class="el-message-box__headerbtn"
                        @click="deleteItem(product.id)"
                      >
                        <i class="el-icon-close"></i>
                      </button>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-divider></el-divider>
            </div>
          </div>
        </el-card>
        <el-card>
          <div slot="header" class="rowStyle">
            <div class="basic-info">
              Fulfilled items
              <el-tag size="mini" type="warning">Fulfilled</el-tag>
            </div>
          </div>
          <div class="clearfix">
            <span>Time of delivery：</span>
            <span>{{
              firstTrack.dateFormatted ? firstTrack.dateFormatted : ""
            }}</span>
          </div>
          <div class="clearfix">
            <span>Shipping address：</span>
            <span>Default</span>
          </div>
          <div class="clearfix">
            <span>Fulfillment method：</span>
            <span>Fulfillment by merchant</span>
          </div>
          <div class="clearfix">
            <span>Tracking number：</span>
            <span>{{ orderNo }}</span>
            <span><i class="el-icon-edit" @click="editOrderNo()"></i></span>
          </div>
          <div class="clearfix">
            <span>Carrier：</span>
            <span>QSY</span>
          </div>
          <div class="clearfix" style="margin-top: 30px">
            <span class="header">Logistics Tracking</span>
          </div>
          <el-divider></el-divider>
          <div class="clearfix">
            <el-row :gutter="20">
              <el-col :span="1.5">
                <div class="clearfix" style="margin-bottom: 0">
                  <span v-if="lastTrack.status === 2"
                    ><i class="el-icon-check track-check"></i
                  ></span>
                  <span v-else-if="lastTrack.status === 1"
                    ><i class="el-icon-truck track-truck"></i
                  ></span>
                  <span v-else><i class="el-icon-time track-time"></i></span>
                </div>
              </el-col>
              <el-col :span="10">
                <div class="clearfix" style="margin-bottom: 0">
                  <span>Tracking number：</span>
                  <span>{{ orderNo }}</span>
                </div>
                <div class="clearfix">
                  <span v-if="lastTrack.status === 2">Delivered </span>
                  <span v-else-if="lastTrack.status === 1">In Transit</span>
                  <span v-else>Can't find out</span>
                </div>
              </el-col>
              <el-col :span="3" style="text-align: right">
                <div class="clearfix" style="margin-bottom: 0">
                  <span>{{ lastTrack.satCountry }}</span>
                </div>
                <div class="clearfix">
                  <span class="track-primary">QSY</span>
                </div>
              </el-col>
              <el-col :span="1">
                <div class="clearfix">
                  <i class="el-icon-sort-up icon-sort-style"></i>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="clearfix">
                  <span class="track-end">{{ lastTrack.endCountry }}</span>
                </div>
              </el-col>
              <!-- <el-col :span="3">
                    <div class="clearfix"  >
                    <span >{{ lastTrack.trackMessage}}</span>
                  </div>
                </el-col> -->
            </el-row>
          </div>
          <div class="clearfix" style="margin-top: 30px">
            <div v-if="isTrackListEmpty">
              <el-empty description="Unable To Track"></el-empty>
            </div>
            <div class="block" v-else>
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(track, index) in trackList"
                  :key="index"
                  :color="index === trackList.length - 1 ? customColor : ''"
                  :timestamp="track.dateFormatted"
                >
                  {{ track.trackMessage }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="7">
        <el-card class="rowStyle">
          <div class="basic-info">Customer's information</div>
          <el-divider></el-divider>
          <div class="clearfix info">
            <span>Customer name</span>
            <span style="float: right">{{
              orderInfo.name ? orderInfo.name : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Email</span>
            <span style="float: right; color: #1f7df8"
              >{{ orderInfo.email ? orderInfo.email : "" }}
              <i class="el-icon-message"></i>
            </span>
          </div>
          <div class="clearfix info">
            <span>Phone number</span>
            <span style="float: right; color: #7e849c">{{
              orderInfo.phone ? orderInfo.phone : ""
            }}</span>
          </div>
        </el-card>
        <el-card class="rowStyle">
          <div class="basic-info">Delivery information</div>
          <el-divider></el-divider>
          <div class="clearfix info">
            <span>Customer name</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.name ? orderInfo.name : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.name" />
          </div>
          <div class="clearfix info">
            <span>Email</span>
            <span v-if="!isEditing" class="value"
              >{{ orderInfo.email ? orderInfo.email : "" }}
            </span>
            <input v-else type="text" v-model="orderInfo.email" />
          </div>
          <div class="clearfix info">
            <span>Phone number</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.phone ? orderInfo.phone : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.phone" />
          </div>
          <div class="clearfix info">
            <span>Country/Region</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.nation ? orderInfo.nation : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.nation" />
          </div>
          <div class="clearfix info">
            <span>Province</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.oblast ? orderInfo.oblast : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.oblast" />
          </div>

          <div class="clearfix info">
            <span>City</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.city ? orderInfo.city : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.city" />
          </div>
          <div class="clearfix info">
            <span>Street</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.location ? orderInfo.location : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.location" />
          </div>
          <div class="clearfix info">
            <span>Postal code</span>
            <span v-if="!isEditing" class="value">{{
              orderInfo.postalCode ? orderInfo.postalCode : ""
            }}</span>
            <input v-else type="text" v-model="orderInfo.postalCode" />
          </div>
        </el-card>
        <el-card class="rowStyle">
          <div class="basic-info">Billing address</div>
          <el-divider></el-divider>
          <div class="clearfix info">
            <span>Customer name</span>
            <span class="value">{{
              orderInfo.name ? orderInfo.name : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Email</span>
            <span class="value"
              >{{ orderInfo.email ? orderInfo.email : "" }}
            </span>
          </div>
          <div class="clearfix info">
            <span>Phone number</span>
            <span class="value">{{
              orderInfo.phone ? orderInfo.phone : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Country/Region</span>
            <span class="value">{{
              orderInfo.nation ? orderInfo.nation : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Province</span>
            <span class="value">{{
              orderInfo.oblast ? orderInfo.oblast : ""
            }}</span>
          </div>

          <div class="clearfix info">
            <span>City</span>
            <span class="value">{{
              orderInfo.city ? orderInfo.city : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Street</span>
            <span class="value">{{
              orderInfo.location ? orderInfo.location : ""
            }}</span>
          </div>
          <div class="clearfix info">
            <span>Postal code</span>
            <span class="value">{{
              orderInfo.postalCode ? orderInfo.postalCode : ""
            }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 编辑图片URL的模态框 -->
    <el-dialog title="编辑图片URL" :visible.sync="dialogVisible" width="30%">
      <el-input
        v-model="editImageUrlInput"
        placeholder="请输入新的图片URL"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveImageUrl">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加商品"
      :visible.sync="dialogAddProdcut"
      width="50%"
      :before-close="handleClose"
    >
      <el-form
        ref="searchForm"
        :model="searchForm"
        class="demo-form-inline"
        inline
      >
        <el-form-item label="商品名称:" prop="like">
          <el-input
            v-model.trim="searchForm.like"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleSearch()"
            >查询
          </el-button>
          <el-button icon="el-icon-refresh-right" @click="handleClear()"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="productData"
        tooltip-effect="dark"
        style="width: 100%"
        height="540"
        :header-cell-style="tableHeaderColor"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="商品图片" width="100">
          <template slot-scope="scope">
            <div>
              <el-popover placement="right" trigger="hover">
                <el-image
                  style="height: 300px"
                  :src="scope.row.pictureUrl"
                  fit="contain"
                />
                <el-image
                  slot="reference"
                  style="height: 100px"
                  :src="scope.row.pictureUrl"
                  fit="contain"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="productName"
          label="商品名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="size"
          label="款式"
          width="100"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        layout="->,total, prev, pager, next, jumper"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddProdcut = false">取 消</el-button>
        <el-button type="primary" @click="submitAddProdcut()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderInfo: {
        id: "",
      },
      formData: [],
      dialogAddProdcut: false,
      customColor: "rgb(11, 189, 135)",
      productInfo: [],
      orderNo: "",
      DeliveryTime: "",
      reverse: true,
      trackInfo: {
        data: [],
      },
      searchForm: {
        //current: 1,
        limit: 50,
        page: 1,
        classify: "",
        like: "",

        // state: "",
      },
      productData: [],
      total: 0,
      multipleSelection: [],
      PriceTotal: 0,
      showForm: false,
      isEditing: false,
      saveForm: {},
      isEditColor: false,
      cart: [], // 购物车数据
      dialogVisible: false,
      editImageUrlInput: "",
      editingRow: null,
      discount: 0,
      freight: 0,
    };
  },
  created() {
    if (this.$route.query.orderNo) {
      this.getOrderDetail();
    }
  },
  methods: {
    async getOrderNo() {
      let url = new URLSearchParams();
      url.append("orderNo", this.orderInfo.orderNo);
      console.log(1, "更新");
      this.$axios
        .post("/track/Logistics/getOrderTrack/orderNo", url)
        .then((res) => {
          if (res.data.code == 200) {
            if (Array.isArray(res.data.data) && res.data.data.length > 0) {
              this.items = res.data.data;
              this.orderNo = this.items[this.items.length - 1];
              this.getTrack();
            } else {
              this.orderNo = "";
              this.$message.error("查询不到物流！");
            }
          } else {
            this.$message.error(result.data.message);
          }
        })
        .catch((err) => {
          this.$message.error("服务器连接失败，请稍后重试......");
        });
    },
    roundToTwo(num) {
      return parseFloat(num.toFixed(2));
    },
    async getPageList() {
      const result = await this.$axios.get("/api/product/info", {
        params: this.searchForm,
      });
      if (result.data.code == 200) {
        this.productData = result.data.data.list;

        this.total = result.data.data.total;
      } else {
        this.$message.error(result.data.message);
      }
    },
    async getOrderDetail() {
      const result = await this.$axios.get("/api/orderccps/list", {
        params: { orderNo: this.$route.query.orderNo },
      });
      if (result.data.code == 200) {
        this.orderInfo = result.data.data.list[0];
        this.productInfo = result.data.data.list[0]["products"];
        this.getOrderNo();
        this.totalPrice();
      } else {
        this.$message.error(result.data.message);
      }
    },
    async getTrack() {
      let url = new URLSearchParams();
      url.append("orderNo", this.orderNo);
      this.$axios
        .post("/track/getOrder", url)
        .then((res) => {
          if (res.data) {
            this.trackInfo.data = res.data;
          }
        })
        .catch((err) => {
          this.$message.error("服务器连接失败，请稍后重试......");
        });
    },
    handleClose() {
      this.dialogAddProdcut = false;
    },
    async handleSave() {
      let products = this.productInfo.map((product) => ({
        productId: product.id,
        classify: product.classify,
        money: product.money,
        orderId: this.orderInfo.orderId,
        orderNo: product.orderNo,
        pictureUrl: product.pictureUrl,
        productName: product.productName,
        size: product.size,
        sum: product.sum,
        url: product.url,
      }));
      this.$axios
        .post("/api/order/update/info", {
          orderNo: this.orderInfo.orderNo,
          orderId: this.orderInfo.orderId,
          productRequest: products,
          orderTime: this.orderInfo.orderTime,
          //  discount:this.orderInfo.discount,
          //  freight:this.orderInfo.freight,
          name: this.orderInfo.name,
          phone: this.orderInfo.phone,
          email: this.orderInfo.email,
          nation: this.orderInfo.nation,
          oblast: this.orderInfo.oblast,
          city: this.orderInfo.city,
          location: this.orderInfo.location,
          postalCode: this.orderInfo.postalCode,
          freight: this.orderInfo.freight,
          discount: this.orderInfo.discount,
        })
        .then((res) => {
          if (res.data) {
            this.$message.success("编辑成功");
          } else {
            this.$message.error("保存失败，参数错误");
          }
        })
        .catch((err) => {
          this.$message.error("服务器连接失败，请稍后重试......");
        });

      this.isEditing = false;
    },
    handleEdit() {
      this.isEditing = true;
    },
    beforeHandleCommand(command, row) {
      return {
        row: row,
        command: command,
      };
    },
    handleCommand(command) {
      switch (command.command) {
        case "a":
          this.searchForm.classify = command.row;
          this.dialogAddProdcut = true;
          this.getPageList();
          break;
        case "e":
          this.handleEdit(command.index, command.row);
          break;
        case "r": //原件整理
          this.fillCartWithRandomProducts();
          break;
      }
    },
    editImageUrl(row) {
      //修改图片url
      this.editingRow = row;
      this.editImageUrlInput = row.pictureUrl;
      this.dialogVisible = true;
    },
    saveImageUrl() {
      if (this.editingRow && this.editImageUrlInput) {
        this.editingRow.pictureUrl = this.editImageUrlInput;
        this.dialogVisible = false;
        this.editingRow = null;
      }
    },
    async fillCartWithRandomProducts() {
      try {
        this.searchForm.classify = this.orderInfo.orderUrl;
        await this.getPageList();
        console.log("getData", this.productData);
        const products = this.productData.map((product) => ({
          ...product,
          money: Number(product.money),
        }));
        products.sort((a, b) => b.money - a.money);
        const targetTotal = this.orderInfo.orderAmount;
        let totalPrice = 0;
        const selectedProducts = new Map();
        let attempts = 0;

        const maxItems = 10;
        const maxAttempts = 100;

        // 主循环
        while (
          totalPrice < targetTotal &&
          Object.keys(selectedProducts).length < maxItems &&
          attempts < maxAttempts
        ) {
          const index = Math.floor(Math.random() * products.length);
          const product = products[index];
          console.log(totalPrice);
          if (Object.keys(selectedProducts).length < maxItems) {
            // 商品种类未达上限，尝试加入新商品
            const maxCount = Math.floor(
              (targetTotal - totalPrice) / product.money
            );
            if (maxCount > 0) {
              selectedProducts.set(
                product,
                (selectedProducts.get(product) || 0) + 1
              );
              totalPrice += product.money;
            }
          } else {
            // 商品种类已达上限，增加已有商品的数量
            console.log("商品种类已达上限，增加已有商品的数量");
            const existingProducts = Array.from(selectedProducts.keys());
            const existingProduct =
              existingProducts[
                Math.floor(Math.random() * existingProducts.length)
              ];
            const maxCount = Math.floor(
              (targetTotal - totalPrice) / existingProduct.money
            );
            if (maxCount > 0) {
              selectedProducts.set(
                existingProduct,
                selectedProducts.get(existingProduct) + 1
              );
              totalPrice += existingProduct.money;
            }
          }

          attempts++;
        }

        //如果未达到目标总价且商品种类已达上限，增加已有商品的数量直到接近目标总价
        if (
          totalPrice < targetTotal &&
          Object.keys(selectedProducts).length === maxItems
        ) {
          while (totalPrice < targetTotal && attempts < maxAttempts) {
            const existingProducts = Array.from(selectedProducts.keys());
            const existingProduct =
              existingProducts[
                Math.floor(Math.random() * existingProducts.length)
              ];
            const maxCount = Math.floor(
              (targetTotal - totalPrice) / existingProduct.money
            );
            if (maxCount > 0) {
              selectedProducts.set(
                existingProduct,
                selectedProducts.get(existingProduct) + 1
              );
              totalPrice += existingProduct.money;
            }
            attempts++;
          }
        }

        // 将 Map 转换成 Array 形式的商品列表
        const resultProducts = Array.from(selectedProducts.entries()).map(
          ([product, count]) => ({ ...product, count })
        );
        this.productInfo = resultProducts;
        this.totalPrice();
        console.log("总价", totalPrice);
        console.log("匹配的商品", selectedProducts);
        console.log("匹配的商品1", resultProducts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async submitAddProdcut() {
      var total = this.PriceTotal;
      this.multipleSelection.forEach((row) => {
        this.productInfo.push(row);
        // row.sum = row.sum ? row.sum : 1;
        // total += row.money * row.sum;
      });
      this.totalPrice();
      this.dialogAddProdcut = false;
      this.multipleSelection = [];
    },
    async totalPrice() {
      var total = 0;
      var freight = Number(0.0);
      var discount = Number(0.0);
      this.productInfo.forEach(function (product) {
        product.sum = product.sum ? product.sum : 1;
        total += product.money * product.sum;
      });
      var PriceNumberTotal = Number(total).toFixed(2);
      var orderAmount = parseFloat(this.orderInfo.orderAmount);
      this.PriceTotal = PriceNumberTotal;

      // 初始运费为订单金额与商品总价之差 orderAmount订单总价  PriceNumberTotal订单总额
      if (PriceNumberTotal > orderAmount) {
        //满减
        // 如果满减超过50元，通过增加运费来调整
        discount = Math.max(0, PriceNumberTotal - orderAmount);
        if (discount > 50) {
          var adjustment = discount - 50; // 超过50元的部分
          freight += adjustment; // 将超过部分加到运费上
          discount = 50; // 重置满减为50元
        }
      } else if (PriceNumberTotal < orderAmount) {
        //运费
        freight = Math.max(0, orderAmount - PriceNumberTotal);
        // 调整运费到1到10元之间
        if (freight < 1 && freight > 0) {
          // var randomNum  = Number((Math.random() * 6 + 1).toFixed(2));
          var randomNum = 5;
          discount = randomNum - freight;
          freight = randomNum;
        }
        // else if (freight > 10) {
        //   discount = freight - 10;
        //   freight = 10.00; // 将运费设为10元
        // }
      }
      this.discount = Number(discount).toFixed(2);
      this.freight = Number(freight).toFixed(2);
    },
    handleChange(value) {
      this.totalPrice();
    },
    deleteItem(itemId) {
      this.productInfo = this.productInfo.filter(
        (proeduct) => proeduct.id !== itemId
      );
      this.totalPrice();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return "background-color:#dee1e9;color:#212121;font-weight: 500;";
    },
    editOrderNo() {
      this.$prompt("请输入Tracking number", "添加物流", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[A-Za-z0-9]+/,
        inputErrorMessage: "Tracking number不正确",
      })
        .then(({ value }) => {
          this.orderNo = value;
          this.getTrack();
          this.$message({
            type: "success",
            message: "添加物流成功，你的Tracking number是: " + value,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    //搜索
    handleSearch() {
      this.searchForm.page = 1;
      this.getPageList();
    },
    //重置
    handleClear() {
      this.$refs["searchForm"].resetFields();
      this.getPageList();
    },
    // 切换每页显示条数
    handleSizeChange(val) {
      this.searchForm.limit = val;
      this.searchForm.page = 1;
      this.getPageList();
    },
    // 点击某一页，跳转某一页
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getPageList();
    },
  },
  computed: {
    // totalPrice:function(){
    //   var total = 0;
    //   this.productInfo.forEach(function(product){
    //     total += product.money * product.sum;
    //   })
    //   return total;
    // },
    isTrackListEmpty() {
      return this.trackList.length === 0;
    },
    trackList: function () {
      return this.trackInfo.data.map((item) => {
        //  const date = new Date(item.trackTime);
        //   const dateFormatted = date.toLocaleDateString(); // 根据需要自定义日期格式
        const dateFormatted =
          item.trackTime.substring(0, 10) +
          " " +
          item.trackTime.substring(11, 19); // 根据需要自定义日期格式
        return {
          ...item,
          dateFormatted,
        };
      });
    },
    lastTrack: function () {
      var trackLists = [];
      if (this.trackList[this.trackList.length - 1]) {
        trackLists = this.trackList[this.trackList.length - 1];
      }
      return trackLists;
    },
    firstTrack: function () {
      var trackLists = [];
      if (this.trackList[0]) {
        trackLists = this.trackList[0];
      }
      return trackLists;
    },
  },
};
</script>

<style scoped>
.basic-info {
  border-left: 5px solid #2661ef;
  padding-left: 10px;
  font-weight: bold;
}

.el-tag {
  margin-left: 5px;
}

.content {
  margin: 20px 0px;
}
.time {
  font-size: 13px;
  color: #999;
}
.clearfix {
  margin-bottom: 10px;
}
.el-card {
  margin-bottom: 16px;
}
.value {
  color: #7e849c;
  float: right;
}
.info-item {
  font-size: 12px;
  color: #6d7175;
  line-height: 15px;
}
.info-name {
  color: #30344f;
  font-weight: bold;
  line-height: 15px;
  font-size: 12px;
}
.item-price {
  font-size: 14px;
  color: #222222;
  font-weight: 500;
}
.header {
  font-weight: bold;
  color: #333;
}
.track-check {
  color: rgb(255, 255, 255);
  width: 40px;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  background-color: green;
  font-size: 20px;
}
.track-truck {
  color: rgb(255, 255, 255);
  width: 40px;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  background-color: #2196f3;
  font-size: 20px;
}
.track-time {
  color: rgb(255, 255, 255);
  width: 40px;
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  background-color: #b71c1c;
  font-size: 20px;
}
.track-primary {
  display: block;
  line-height: 16px;
  font-size: 12px;
  font-style: normal;
  color: #003a9b;
}
.icon-sort-style {
  height: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  /* 翻转180度 */

  font-size: 20px;
  transform: rotate(90deg);
}
.track-end {
  height: 40px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;

  align-content: center;
}
.last-item-custom-color {
  color: #ff0000 !important; /* 红色 */
}
/* 通过class来指定最后一个节点的样式 */
.el-timeline-item__node--normal:last-child {
  background-color: v-bind(customColor) !important;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/view/order/Detail.vue